export default __webpack_public_path__ + "static/media/Shape.8487903b.svg";